"use client"

import { cn } from "@/utils/cn"

interface SwitchProps {
  label: string
  className?: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  required?: boolean
}

function Switch({
  className,
  checked,
  onCheckedChange,
  label,
  required,
  ...props
}: SwitchProps) {
  return (
    <label
      className={cn(
        "flex items-center gap-2 font-family-gtpressura font-light text-neutral-dark",
        className
      )}
      onClick={() => onCheckedChange(!checked)}
      {...props}
    >
      <div
        className={cn(
          "focus-visible:border-ring focus-visible:ring-ring/50 inline-flex w-9.5 items-center rounded-full border border-primary-500 bg-green-500 p-0.5 shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
          !checked && "opacity-75 grayscale-100"
        )}
      >
        <div
          className={cn(
            "pointer-events-none size-4 rounded-full bg-primary-500 ring-0 transition-transform",
            !checked ? "translate-x-0" : "translate-x-full"
          )}
        />
      </div>
      <p>
        {label}
        {required && <span className="text-red-500"> *</span>}
      </p>
    </label>
  )
}

export { Switch }
